import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { RootState } from 'src/store';
import { IMenuState } from 'src/store/slices/index';
import { FUNJET_LINK, Routes } from 'src/constants/index';
import { BlueButton, Membership } from 'src/components/components/index';
import { inclusivesGalery, AllInclusivesCompanyLogos } from 'src/common-types/index';
import InclusivesBackground from 'src/assets/images/inclusives/bg-inclusives.png';
import ConciergeTeam from 'src/assets/images/concierge-team.png';
import './style.scss';

interface IMapStateToProps {
  menuStore: IMenuState;
}

interface IProps extends IMapStateToProps {}

class AllInclusivesWrapperComponent extends React.Component<IProps, null> {
  render(): React.ReactNode {
    const { menuStore } = this.props;
    const phone = menuStore.items?.phone;

    return (
      <div className="inclusives">
        <div
          className="inclusives__header"
          style={{ backgroundImage: `url(${InclusivesBackground})` }}
        >
          <div className="inclusives__container">
            <h1 className="inclusives__header_title">
              <FormattedMessage id="inclusives.title" />
            </h1>
            <p className="inclusives__header_subtitle">
              <FormattedMessage id="inclusives.subtitle" />
            </p>
          </div>
        </div>
        <div>
          <div className="inclusives__container inclusives__book">
            <div className="inclusives__book_info">
              <h2 className="inclusives__book_title">
                <FormattedMessage id="inclusives.book.title" />
              </h2>
              <p className="inclusives__book_subtitle">
                <FormattedMessage id="inclusives.book.subtitle" />
              </p>
              <p className="inclusives__book_text">
                <FormattedMessage id="inclusives.book.text" />
              </p>
              <p className="inclusives__book_text">
                <FormattedMessage id="inclusives.book.text.bottom" />
              </p>
            </div>
            <img className="inclusives__book_img" src={ConciergeTeam} alt="inclusives" />
          </div>
        </div>
        <div className="inclusives__vacation">
          <div className="inclusives__container">
            <h2 className="inclusives__vacation_title">
              <FormattedMessage id="inclusives.vacation.title" />
            </h2>
            <p className="inclusives__vacation_subtitle">
              <FormattedMessage id="inclusives.vacation.subtitle" />
            </p>
            <div className="inclusives__vacation_info">
              <p className="inclusives__vacation_text">
                <FormattedMessage id="inclusives.vacation.text.left" />
              </p>
              <p className="inclusives__vacation_text">
                <span>
                  <FormattedMessage id="inclusives.vacation.text.right" />
                </span>{' '}
                <FormattedMessage id="inclusives.vacation.text.right.bottom" />
              </p>
            </div>
            <div className="inclusives__vacation_bottom">
              <a href={FUNJET_LINK} target="_blank" rel="noreferrer">
                <BlueButton>
                  <FormattedMessage id="go.to.funjet" />
                </BlueButton>
              </a>
            </div>
          </div>
        </div>
        <div className="inclusives__gallery">
          {inclusivesGalery.map((item, index) => (
            <img
              key={`inclusives galery ${index}`}
              className="inclusives__gallery_img"
              src={item.url}
              alt="gallery-img"
            />
          ))}
        </div>
        <div className="inclusives__tell">
          <div className="inclusives__container">
            <p className="inclusives__tell_title">
              <FormattedMessage id="inclusives.tell.title" />
            </p>
            <div className="inclusives__tell_info">
              <p className="inclusives__tell_text">
                <FormattedMessage id="inclusives.tell.text" />
              </p>
              <Link className="inclusives__tell_link" to={`${Routes.AllInclusive}/submit-request`}>
                <BlueButton>
                  <FormattedMessage id="inclusives.tell.us" />
                </BlueButton>
              </Link>
            </div>
          </div>
        </div>
        <div className="inclusives__all">
          <div className="inclusives__container">
            <h2 className="inclusives__all_title">
              <FormattedMessage id="inclusives.all.title" />
            </h2>
            <p className="inclusives__all_subtitle">
              <FormattedMessage id="inclusives.all.subtitle" />
            </p>
            <p className="inclusives__all_text">
              <FormattedMessage id="inclusives.all.text" />
            </p>
            <p className="inclusives__all_subtitle">
              <FormattedMessage id="inclusives.all.subtitle.bottom" />
            </p>
            <p className="inclusives__all_text">
              <FormattedMessage id="inclusives.all.text.bottom" />
            </p>
            <p className="inclusives__all_link">
              <FormattedMessage id="inclusives.all.link" />
            </p>
          </div>
        </div>
        <div className="inclusives__partners">
          <div className="inclusives__container">
            <h2 className="inclusives__partners_title">
              <FormattedMessage id="treat.yourself.book.with.our.team" />
              {': '}
              <a href={`tel:${phone}`}>{phone}</a>
            </h2>
            <p className="inclusives__partners_subtitle">
              <FormattedMessage id="your.award.winning.travel" />
            </p>
            <p className="inclusives__partners_text">
              <FormattedMessage id="travel.partners.and.cruise.lines" />
            </p>
            <div className="inclusives__partners_divider" />
            <p className="inclusives__partners_subtitle">
              <FormattedMessage id="travel.partners.and.cruise.partners" />
            </p>
            <div className="inclusives__partners_wrapper">
              {AllInclusivesCompanyLogos.map((item, index) => (
                <div key={`${index}-${item.name}`} className="inclusives__partners_wrapper_item">
                  <img
                    src={item.image}
                    key={`inclusives company galery ${item.name}`}
                    alt={`inclusives gallery-img ${item.name}`}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <Membership />
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    menuStore: state.navigationMenuStore,
  };
};

export const AllInclusivesWrapper = connect(mapStateToProps, null)(AllInclusivesWrapperComponent);
